import React from "react";
import KickImage from 'Reuseables/KickImage';
import propTypes from "prop-types";
import { getCacheImage } from "../../../../config";

const NoThumbnail = ({ src, alt }) => {
  return (
    <div className="empty-images-container">
      <div className="empty-images-container__body">
        <KickImage src={getCacheImage(src)} alt={alt} />
      </div>
    </div>
  );
};

NoThumbnail.propTypes = {
  src: propTypes.string,
  alt: propTypes.string
};

export default NoThumbnail;
